<script lang="ts" setup>
import { setup, Props, Emit } from './eventAlertInformation.setup';
import RuleDataSection from './RuleDataSection.vue';
import SystemRuleDataSection from './SystemRuleDataSection.vue';
import OccurrenceMessageSection from './OccurrenceMessageSection.vue';
import DetailInformation from '@/common/components/molecules/DetailInformation.vue';
import AlertHostProcessList from './AlertHostProcessList.vue';
import { ALERT_TYPE_VALUE } from '@/alert/utils/define';
import { USER_ENV_KEYS } from '@/common/define/userEnv.define';

const props = defineProps<Props>();
const emit = defineEmits<Emit>();

const {
  t,
  PATH_COLUMNS,
  onClickStatusIcon,
  metricInfos,
  pathRows,
  occurrenceItems,
  ruleGroups,
  contentItemMinWidth,
  alertRuleType,
  ruleCriteria,
  metricConditionSubType,
  systemAlertDetails,
  isProcessStatusDetection,
  processHostId,
} = setup(props, emit);
</script>

<template>
  <section
    :class="[
      'event-alert-information',
      { 'event-alert-information--fill': isProcessStatusDetection },
    ]"
  >
    <!-- 시스템 타입: 커스텀 룰 데이터 + 그리드 -->
    <system-rule-data-section
      v-if="alertRuleType === ALERT_TYPE_VALUE.SYSTEM && systemAlertDetails.length > 0"
      :system-alert-details="systemAlertDetails"
    />

    <!-- 비시스템 타입 또는 시스템 데이터 없을 때: 기존 룰 데이터 섹션 -->
    <rule-data-section
      v-else
      :rule-groups="ruleGroups"
    />

    <!-- 이벤트 발생 메시지 영역 -->
    <occurrence-message-section
      :occurrence-items="occurrenceItems"
      :alert-rule-type="alertRuleType"
      :rule-criteria="ruleCriteria"
      :metric-sub-type="metricConditionSubType"
      :metric-infos="metricInfos"
      :path-rows="pathRows"
      :path-columns="PATH_COLUMNS"
      :content-item-min-width="contentItemMinWidth"
      :system-alert-details="systemAlertDetails"
      @click-status-icon="onClickStatusIcon"
    />

    <!-- 프로세스 상태 감지: 대상 호스트의 프로세스 목록 -->
    <detail-information
      v-if="isProcessStatusDetection"
      :title="t('WORD.PROCESS_LIST')"
      use-expand
      :expand-env-key="USER_ENV_KEYS.TOGGLE_alert_eventAlertDetail_processList_expanded"
      class="event-alert-process-list"
    >
      <template #content>
        <alert-host-process-list
          :is-show="props.isShow"
          :host-id="processHostId"
        />
      </template>
    </detail-information>
  </section>
</template>

<style scoped lang="scss">
.event-alert-information {
  display: flex;
  flex-direction: column;
  gap: 12px;

  // 프로세스 목록이 있는 이벤트: 상단 섹션 접힘에 따라 프로세스 목록이 남은 세로 공간을 채우도록 flex 레이아웃
  &--fill {
    height: 100%;
    min-height: 0;

    // 프로세스 목록 섹션(펼침 상태)만 남은 공간 차지, 접으면 헤더만
    .event-alert-process-list.expanded {
      display: flex;
      flex: 1;
      flex-direction: column;
      min-height: 250px; // 최소 높이 floor. 공간 부족 시 바디가 스크롤

      :deep(.detail-information__content) {
        flex: 1;
        min-height: 0; // 그리드를 남은 공간에 맞게 축소 + 내부 스크롤(전체 행으로 늘어나 화면 초과 방지)
        overflow: hidden;
      }
    }
  }
}
</style>
